import useSetInterval from './useSetInterval';

export default useSetInterval;
